// LE place IDs are `le_` + hex digest (MD5). Map-area searches store Google
// LatLngBounds URL values ("lat_lo,lng_lo,lat_hi,lng_hi") in destination_ids
// instead — those must not be sent to /api/search/place/v1/places.
const LE_PLACE_ID_PATTERN = /^le_[a-f0-9]+$/i;
const NUMERIC_SEGMENT_PATTERN = /^-?\d+(\.\d+)?$/;

export function isLePlaceId(id: string): boolean {
  return LE_PLACE_ID_PATTERN.test(id);
}

export function filterLePlaceIds(ids: Array<string>): Array<string> {
  return ids.filter(isLePlaceId);
}

export function isGoogleBoundsUrlValue(value: string): boolean {
  const segments = value.split(',');
  if (segments.length !== 4) {
    return false;
  }

  if (!segments.every((segment) => NUMERIC_SEGMENT_PATTERN.test(segment.trim()))) {
    return false;
  }

  const [latLo, lngLo, latHi, lngHi] = segments.map((segment) => parseFloat(segment.trim()));
  return latLo !== latHi && lngLo !== lngHi;
}

export function googleBoundsUrlValueToPolygonGeom(value: string): {
  type: 'Polygon';
  coordinates: Array<Array<[number, number]>>;
} | null {
  if (!isGoogleBoundsUrlValue(value)) {
    return null;
  }

  const [latLo, lngLo, latHi, lngHi] = value.split(',').map((segment) => parseFloat(segment.trim()));

  // GeoJSON polygons are [lng, lat]
  return {
    type: 'Polygon',
    coordinates: [
      [
        [lngLo, latLo],
        [lngHi, latLo],
        [lngHi, latHi],
        [lngLo, latHi],
        [lngLo, latLo],
      ],
    ],
  };
}
